import UploadLogo from '../../../common/UploadLogo';
import UploadStamp from '../../../common/UploadStamp';
import ExporterDetails from '../../PackingListFormComponents/ExporterDetails';
import BuyerDetails from '../../PackingListFormComponents/BuyerDetails';
import { PackingListInterface } from '../../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/parkinglistTypes';

const StepOne = ({
    updateField,
    payload,
    corporatePartners,
    loadingCorporatepartners,
    setShowAddPartner,
    errors
}: PackingListInterface) => {
    return (
        <div className='w-full flex flex-col gap-4'>
            <UploadLogo {...{ payload, updateField }} />

            <UploadStamp {...{ payload, updateField }} />

            <ExporterDetails
                {...{
                    errors,
                    payload,
                    corporatePartners,
                    updateField,
                    loadingCorporatepartners,
                    setShowAddPartner
                }}
            />

            <BuyerDetails
                {...{
                    errors,
                    payload,
                    corporatePartners,
                    updateField,
                    loadingCorporatepartners,
                    setShowAddPartner
                }}
            />
        </div>
    );
};

export default StepOne;
